module.exports = __webpack_public_path__ + "img/skyline-logo-black.517a750f.svg";